import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Button } from "react-bootstrap";

class Cancel extends Component {
  render() {
    const { stores } = this.props;
    return <Button {...this.props}>{stores.ui.translate.Cancel}</Button>;
  }
}

export default inject("stores")(observer(Cancel));



// WEBPACK FOOTER //
// ./src/Core/Components/Buttons/Cancel.js